import React from 'react';
import { Link } from 'react-router-dom';

import { isExternal } from 'helpers/http';

import AbstractCmsElement from './AbstractCmsElement';

export default class CmsElementNavigationChild extends AbstractCmsElement {
  render() {
    const icon = this.getParamValue('icon', '');
    const title = this.getParamValue('title', '');
    const link = this.getParamValue('link', '');

    const isExternalLink = isExternal(link);
    const LinkComponent = isExternalLink ? 'a' : Link;
    const linkProps = {
      className: 'ms-navigation-child-link',
      to: (!isExternalLink && link) || undefined,
      href: (isExternalLink && link) || undefined,
      target: isExternalLink ? '_blank' : undefined,
      rel: isExternalLink ? 'noopener noreferrer' : undefined,
    };

    return (
      <li id={this.getMainId()} className="ms-navigation-child">
        {this.getElementStyle()}

        <LinkComponent {...linkProps}>
          {icon ? <i className={'fa ' + icon + ' m-r-5'} /> : null}
          {title}
        </LinkComponent>
      </li>
    );
  }
}
CmsElementNavigationChild.defaultProps = {
  index: '0',
};
